import styled from "styled-components";

export const ChatBoxWrapper = styled.div`
  border: 1px solid #c9d4db;
  border-radius: 3px;
  width: 100%;
  background-color: rgba(228, 233, 236, 0.17);
  padding: 20px;
`;

export const FileLabel = styled.h4`
  color: #424f5c;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 10px;
`;
